import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Breadcrumb from "../../../components/layout/Breadcrumb";
import { createAnnouncement } from "../../../redux/slice/announcementsSlice";
import { useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { Editor } from "@tinymce/tinymce-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AnnouncementCreate() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [errors, setErrors] = useState({
    title: false,
    content: false,
  });

  const [title, setTitle] = useState("");
  const [contentHtml, setContentHtml] = useState("");
  const [status, setStatus] = useState("DRAFT");
  const [publishAt, setPublishAt] = useState("");

  const tinyConfig = {
    height: 500,
    menubar: "file edit view insert format tools table image help",
    branding: false,
    promotion: false,
    statusbar: true,
    resize: true,

    plugins: [
      "advlist", "autolink", "lists", "link", "image", "charmap", "preview", "anchor",
      "searchreplace", "visualblocks", "code", "fullscreen", "insertdatetime",
      "media", "table", "help", "wordcount"
    ],

    toolbar:
      "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | " +
      "image | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | " +
      "link media table | searchreplace preview fullscreen code | help",

    content_style:
      "body { font-family: Helvetica, Arial, sans-serif; font-size:14px }",
    image_title: false,
    image_dimensions: false,
    image_advtab: false,
    file_picker_types: "image",

    file_picker_callback: (callback, value, meta) => {
      if (meta.filetype !== "image") return;
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.onchange = () => {
        const file = input.files[0];
        const reader = new FileReader();
        reader.onload = () => {
          callback(reader.result, { alt: file.name });
        };
        reader.readAsDataURL(file);
      };
      input.click();
    },

    images_upload_handler: (blobInfo) =>
      new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(blobInfo.blob());
      }),
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isTitleEmpty = !title.trim();
    const isContentEmpty = !contentHtml || contentHtml.trim() === "";

    if (isTitleEmpty || isContentEmpty) {
      setErrors({
        title: isTitleEmpty,
        content: isContentEmpty,
      });
      toast.error("Please fill all required fields.", { className: "toast-error-custom", });
      return;
    }

    if (status === "SCHEDULED" && !publishAt) {
      toast.error("Publish date is required for scheduled announcements.", { className: "toast-error-custom", });
      return;
    }

    const payload = {
      title,
      content: contentHtml,
      status,
      type: "ANNOUNCEMENT",
      ...(status === "SCHEDULED" && { publishAt }),
    };

    try {
      const res = await dispatch(createAnnouncement(payload)).unwrap();
      console.log(res);
      toast.success("Announcement created successfully!", { className: "toast-success-custom" });
      navigate("/admin/announcements");

    } catch (error) {
      toast.error(error || "Failed to create announcement.", { className: "toast-error-custom" });
    }

  };

  return (
    <>
      <div className="section-body policy-update">
        <div className="container-fluid">
          <h5 className="mb-3 mt-1">Create Announcement</h5>
          <div className="d-flex justify-content-between mt-3 mb-4 align-middle">
            <Breadcrumb />
            <div className="d-flex align-items-end">
              <div className="policy-status-toggle me-3">
                <input type="radio" id="publish" name="announcementStatus" checked={status === "PUBLISHED"} onChange={() => setStatus("PUBLISHED")} />
                <label htmlFor="publish" className="publish m-0">
                  Publish
                </label>

                <input
                  type="radio" id="draft" name="announcementStatus" checked={status === "DRAFT"} onChange={() => setStatus("DRAFT")} />
                <label htmlFor="draft" className="draft m-0">
                  Draft
                </label>

                <input type="radio" id="scheduled" name="announcementStatus" checked={status === "SCHEDULED"} onChange={() => setStatus("SCHEDULED")} />
                <label htmlFor="scheduled" className="scheduled m-0">
                  Schedule
                </label>
              </div>

              <Button type="submit" form="announcementCreateForm" className="primary-btn ml-4" >
                Save Announcement
              </Button>
            </div>
          </div>


          <div className="card mb-5">
            <div className="card-header">
              <Form id="announcementCreateForm" onSubmit={handleSubmit}>

                <Form.Group className="mb-3">
                  <Form.Label>
                    <strong>Announcement Title:</strong>
                  </Form.Label>
                  <Form.Control
                    value={title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                      if (errors.title) {
                        setErrors((prev) => ({ ...prev, title: false }));
                      }
                    }}
                    className={errors.title ? "is-invalid" : ""}
                  />
                  {errors.title && (
                    <div className="invalid-feedback">
                      Announcement title is required
                    </div>
                  )}
                </Form.Group>

                {status === "SCHEDULED" && (
                  <Form.Group className="mb-3">
                    <Form.Label>
                      <strong>Publish Date & Time:</strong>
                    </Form.Label>
                    <Form.Control
                      type="datetime-local"
                      value={publishAt}
                      onChange={(e) => setPublishAt(e.target.value)}
                      required
                    />
                  </Form.Group>
                )}

                <Form.Group className="mb-4">
                  <Form.Label>
                    <strong>Announcement Content:</strong>
                  </Form.Label>
                  <div className={errors.content ? "is-invalid-editor" : ""}>
                    <Editor
                      value={contentHtml}
                      onEditorChange={(html) => {
                        setContentHtml(html);
                        if (errors.content) {
                          setErrors((prev) => ({
                            ...prev,
                            content: false,
                          }));
                        }
                      }}
                      init={tinyConfig}
                      apiKey="x1zlwv4dd93x8wuuh7iovblba5p75zd4iwk50u953zh33s2p"
                    //apiKey={process.env.x1zlwv4dd93x8wuuh7iovblba5p75zd4iwk50u953zh33s2p}
                    />
                  </div>
                  {errors.content && (
                    <div className="invalid-feedback d-block">
                      Announcement content is required
                    </div>
                  )}
                </Form.Group>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}
